<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>直连插件监控器</el-breadcrumb-item>
    </el-breadcrumb>
    <h1 class="view-head">
      直连插件监控器
      <div class="title-btn">
        <el-button
          type="warning"
          plain
          @click="exportFile"
          v-if="$store.state.funcModuleArray.includes(1901050104)"
          >导出</el-button
        >
      </div>
    </h1>
    <div class="view-content">
      <el-card class="box-card">
        <div class="view-filter">
          <span>状态筛选:</span>
          <el-select
            v-model="connect_type"
            size="small"
            style="margin-right: 10px;margin-left: 10px;width: 100px;"
          >
            <el-option label="全部" value="0"> </el-option>
            <el-option label="正常" value="1"> </el-option>
            <el-option label="断开" value="2"> </el-option>
          </el-select>
          <span>抓取类型:</span>
          <el-select
            v-model="plugin_type"
            size="small"
            style="margin-right: 10px;margin-left: 10px;width: 100px;"
          >
            <el-option
              v-for="(item, index) in reportList"
              :label="item.value"
              :value="item.key"
            ></el-option>
          </el-select>

          <el-input
            v-model="search_text"
            class="search-text"
            size="small"
            placeholder="请输入编码或名称"
          >
            <el-button slot="append" @click="onSearch">查找</el-button>
          </el-input>
        </div>

        <div class="card-content">
          <div
            style="display: flex;
    justify-content: space-between;"
          >
            <div class="table-tool">共{{ totalCount }}条</div>
            <div class="count_page">
              每页
              <el-select
                style="width:70px"
                v-model="page_size"
                @change="onSearch"
              >
                <el-option label="20" value="20"></el-option>
                <el-option label="50" value="50"></el-option>
                <el-option label="100" value="100"></el-option> </el-select
              >条
            </div>
          </div>
          <el-table v-loading="loading" :data="tableData" style="width: 100%">
            <el-table-column prop="plugin_code" label="插件编码">
            </el-table-column>
            <el-table-column prop="client_code" label="经销商编码（我方）">
            </el-table-column>
            <el-table-column prop="client_name" label="经销商名称（我方）">
              <template slot-scope="scope">
                <div class="dealer-name-wrapper">
                  <span class="dealer-name">{{ scope.row.client_name }}</span>
                  <el-tag 
                    v-if="scope.row.is_new === 1" 
                    class="new-tag"
                    size="small"
                  >新</el-tag>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="plugin_type_desc" label="抓取类型">
            </el-table-column>
            <el-table-column prop="edition_code" width="100" label="抓取服务">
            </el-table-column>
            <el-table-column prop="edition_code3" width="100" label="更新服务">
            </el-table-column>
            <el-table-column
              prop="edition_code2"
              width="120"
              label="应用服务更新"
            >
            </el-table-column>
            <el-table-column prop="connect_status" label="连接状态">
              <template slot-scope="scope">
                <el-tag :type="scope.row.connect_status === '断开' ? 'danger' : 'success'"
                        v-if="scope.row.is_new != 1"
                        disable-transitions>{{scope.row.connect_status}}
                </el-tag>
                <el-tag :type="scope.row.new_plugin_connect_status != 1 ? 'danger' : 'success'"
                        v-if="scope.row.is_new == 1"
                        disable-transitions>{{scope.row.new_plugin_connect_status == 1 ? '正常' : '断开'}}
                </el-tag>
                <el-tooltip class="item" effect="dark" :content="'老插件：' + scope.row.connect_status" placement="right"
                  v-if="scope.row.is_old == 1 && scope.row.is_new == 1"
                  >
                  <i class="el-icon-warning-outline" style="color: red;margin-left: 5px;"></i>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column prop="last_log_create_time" label="最近一次监控时间">
               <template slot-scope="scope">
                <span v-if="scope.row.is_new != 1">{{scope.row.last_log_create_time!=""?scope.row.last_log_create_time:"暂无"}}</span>
                <span v-if="scope.row.is_new == 1">{{scope.row.new_plugin_connect_time ? scope.row.new_plugin_connect_time:"暂无"}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="last_upload_time" label="上次上传文件时间">
              <template slot-scope="scope">
                <span v-if="scope.row.is_new != 1">{{scope.row.last_upload_time}}</span>
                <span v-if="scope.row.is_new == 1">{{scope.row.new_plugin_upload_time ? scope.row.new_plugin_upload_time:"暂无"}}</span>
              </template>
            </el-table-column>
            </el-table-column>
            <el-table-column prop="remark" label="备注">
              <template slot-scope="scope">
                <div class="clamp-2" :title="titleMultiLine(scope.row.remark)">
                  {{ scope.row.remark }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="operate"
              width="300"
              label="操作"
              v-if="
                $store.state.funcModuleArray.includes(1901050101) ||
                  $store.state.funcModuleArray.includes(1901050102) ||
                  $store.state.funcModuleArray.includes(1901050103)
              "
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="examine(scope.row)"
                  v-if="$store.state.funcModuleArray.includes(1901050101)"
                  >查看日志</el-button
                >
                <el-button
                  type="text"
                  @click="seeSql(scope.row)"
                  v-if="$store.state.funcModuleArray.includes(1901050102)"
                  >查看SQL</el-button
                >
                <el-button
                  type="text"
                  @click="addRemark(scope.row)"
                  v-if="$store.state.funcModuleArray.includes(1901050103)"
                  >添加备注</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="block" v-if="totalPage > 1">
          <el-pagination
            background
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-size="page_size"
            layout="prev, pager, next, jumper"
            :total="totalCount"
          >
          </el-pagination>
        </div>
      </el-card>
    </div>

    <el-dialog title="添加备注" :visible.sync="visible">
      <el-input
        rows="8"
        placeholder="请输入备注内容，最多300个字"
        maxlength="300"
        type="textarea"
        v-model="remark"
      ></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取 消</el-button>
        <el-button type="primary" @click="save">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { pluginList, enumBusinessList, editPluginConnect } from "@/api/index";
import { exportPluginPageList } from "@/api/export";
import { titleMultiLine } from "@/util";
export default {
  name: "plugInMonitoring",
  data: () => ({
    currentPage: 1,
    search_text: "",
    totalCount: 0,
    totalPage: 0,
    tableData: [],
    connect_type: "0",
    plugin_type: 0,
    reportList: [],
    loading: false,
    visible: false,
    remark: "",
    plugin_connect_id: "",
    page_size: "20"
  }),
  created() {
    // this._getList(1);
  },
  mounted() {
    this.getenumBusinessList();
  },
  methods: {
    titleMultiLine,
    getenumBusinessList() {
      let par = {
        enum_name_arr: ["ZlPluginTypeEnum"]
      };
      enumBusinessList(par).then(res => {
        if (res.status == 0) {
          let data = res.data;
          for (const iterator of data) {
            for (const key in iterator) {
              if (Object.hasOwnProperty.call(iterator, key)) {
                const element = iterator[key];
                this.reportList = element;
              }
            }
          }
          this._getList(1);
        }
      });
    },
    _getList(page) {
      this.loading = true;
      pluginList(
        page,
        this.search_text,
        this.connect_type,
        this.plugin_type,
        this.page_size
      ).then(res => {
        this.loading = false;
        if (0 === res.status) {
          this.tableData = res.data.list;
          this.totalCount = res.data.totalCount;
          this.currentPage = parseInt(res.data.currentPage);
          this.totalPage = res.data.totalPage;
        } else {
          this.tableData = [];
          this.currentPage = 1;
          this.totalCount = 0;
          this.totalPage = 0;
        }
      });
    },
    onSearch() {
      this._getList(1);
    },
    handleCurrentChange(val) {
      this._getList(val);
    },
    examine(row) {
      this.$router.push({
        name: "monitoringManageViewLog",
        params: {
          plugin_code: row.plugin_code,
          client_code: row.client_code,
          client_name: row.client_name
        },
        query: {
          is_new: row.is_new
        }
      });
    },
    seeSql(row) {
      this.$router.push({
        name: "monitoringManageRemoteSql",
        params: { plugin_code: row.plugin_code, client_code: row.client_code }
      });
    },
    addRemark(row) {
      console.log(row, "rowowwwowoow");
      this.remark = row.remark;
      this.plugin_connect_id = row.plugin_connect_id;
      this.visible = true;
    },
    save() {
      let params = {
        plugin_connect_id: this.plugin_connect_id,
        remark: this.remark
      };
      this.visible = false;
      editPluginConnect(params).then(res => {
        if (0 === res.status) {
          this.$message({
            message: res.msg,
            type: "success"
          });
          this._getList(1);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    exportFile() {
      let parameter = {
        find_value: this.search_text,
        connect_type: this.connect_type,
        plugin_type: this.plugin_type,
        export: 1
      };
      exportPluginPageList(parameter);
    }
  }
};
</script>

<style scoped lang="scss">
.view-filter {
  margin-bottom: 20px;
}

.search-text {
  margin-right: 10px;
  width: 300px;
}

.count_page {
  margin: -20px 0 10px 0;
}
.clamp-2 {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}

.dealer-name-wrapper {
  display: flex;
  align-items: center;
  gap: 6px;
}

.dealer-name {
  flex: 1;
  word-wrap: break-word;
  word-break: break-all;
}

.new-tag {
  flex-shrink: 0;
  color: white;
  background-color: #409EFF;
}
</style>
